<template>
  <div class="incenters" style="margin-left: 0px;">
    <div>
      <Commonbtn backgroundColor="#FFF" :src="require('@/assets/icon/icon-add.png')" title="选择" fontSize="14px" @btnclick="clooesclick">
      </Commonbtn>
      <Commonbtn backgroundColor="#FFF" :src="require('@/assets/icon/icon-add.png')" title="导出" fontSize="14px" @btnclick="dcclick">
      </Commonbtn>
    </div>
    <div style="overflow: hidden;">
      <Commontable :rowhe="true" width="1000px" colnum=7 :tableData="tableDatas" :headerData="headerData" height="100%"></Commontable>
       <div class="paginations">
        <Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="totals"></Pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Commontable from '../../../../../components/common-table.vue'
import Commonbtn from '../../../../../components/common-btn.vue'
import DialogFrom from '../../../../../components/dialog-from.vue'
import CommonBtngroup from '../../../../../components/commongroup.vue'
import Commondropdownlist from '../../../../../components/common-dropdownlist.vue'
import Pagination from '../../../../../components/pagination.vue'
// import addlistfrom from '../../fromData/addlistfrom'

export default {
  name: "WarehouserarTable",
  components: {
    Commontable,
    Commonbtn,
    DialogFrom,
    CommonBtngroup,
    Commondropdownlist,
    Pagination
  },
  props: {
    tableDatas: {
      type: Array,
      default: []
    },
    totals: {
      type: Number,
      default: 0
    }
  },
  data: function () {

    return {
      fromdataadd: [],
      dialogVisibleSelectproduct: false,
      showorhide: true,
      tableData: [
      ],
      headerData: [
        {
          prop: 'id',
          label: '序号',
          columnwidth: 120
        },
        {
          prop: 'CusCode',
          label: '客户编码',
          columnwidth: 200
        },
        {
          prop: 'CusName',
          label: '客户名称',
          columnwidth: 200
        },
        {
          prop: 'CusTypeName',
          label: '客户类型',
          columnwidth: 150
        },
        {
          prop: 'CusEName',
          label: '客户英文名称',
          columnwidth: 150
        },
        {
          prop: 'CusAbbName',
          label: '客户简称',
          columnwidth: 230
        },
        {
          prop: 'CompanyName',
          label: '一级经销商名称',
          columnwidth: 160
        },
        {
          prop: 'province',
          label: '经营省份',
          columnwidth: 150
        },
        {
          prop: 'province',
          label: '省份',
          columnwidth: 230
        },
        {
          prop: 'city',
          label: '城市',
          columnwidth: 160
        },
        {
          prop: 'district',
          label: '区县',
          columnwidth: 160
        }, {
          prop: 'Address',
          label: '详细地址',
          columnwidth: 160
        },
        {
          prop: 'LinkMan',
          label: '联系人',
          columnwidth: 160
        },
        {
          prop: 'LinkPhone',
          label: '联系方式',
          columnwidth: 160
        }, {
          prop: 'LicenseNo',
          label: '经营许可证',
          columnwidth: 160
        },
        {
          prop: 'VoucherNo',
          label: '备案凭证编号',
          columnwidth: 160
        }
        ,
        {
          prop: 'VoucherMDate',
          label: '备案凭证有效起始日期',
          columnwidth: 160
        }, {
          prop: 'LicenseMDate',
          label: '经营许可证有效起始日期',
          columnwidth: 160
        },
        {
          prop: 'VoucherVDate',
          label: '备案凭证有效结束日期',
          columnwidth: 160
        }

        ,
        {
          prop: 'CompanyInCharge',
          label: '企业负责人',
          columnwidth: 160
        }, {
          prop: 'BusinessAddress',
          label: '经营地址',
          columnwidth: 160
        },
        {
          prop: 'CompanyInLaw',
          label: '法人代表',
          columnwidth: 160
        }
        ,
        {
          prop: 'WarehouseAddress',
          label: '仓库地址',
          columnwidth: 160
        }, {
          prop: 'Password',
          label: '密码',
          columnwidth: 160
        },
        {
          prop: 'Actived',
          label: '是否启用',
          columnwidth: 160
        }, {
          prop: 'Creator',
          label: '创建人',
          columnwidth: 160
        },
        {
          prop: 'CreateTime',
          label: '创建时间',
          columnwidth: 160
        }, {
          prop: 'Updater',
          label: '修改人',
          columnwidth: 160
        },
        {
          prop: 'UpdateTime',
          label: '修改时间',
          columnwidth: 160
        }, {
          prop: 'Activor',
          label: '停启用人',
          columnwidth: 160
        },
        {
          prop: 'ActiveTime',
          label: '停启用时间',
          columnwidth: 160
        }
      ],
      onchage: 0,
      tableflag: true,
      tableflags: false,
    }
  },
  created() {
  },
  mounted() {
    // this.fromdataadd = JSON.parse(JSON.stringify(addlistfrom))
  },
  methods: {
    
    clicktab(index) {
      if (index == 0) {
        this.tableflag = true
        this.tableflags = false
      }
      if (index == 1) {
        this.tableflag = false
        this.tableflags = true
      }
      if (this.onchage != index) {
        this.onchage = index
      }
    },
    showclick() {
      this.showorhide = true
    },
    hide() {
      this.showorhide = false
      //console.log("askdas", this.showorhide)

    },
    delclick() {

    },
    select() {

    },
    reset() {

    },
    clooesclick(){

    },
    dcclick(){

    },
    cancelSelectproduct() {
      this.dialogVisibleSelectproduct = false
    },
    dialogOKcancelSelectproduct() {
      this.dialogVisibleSelectproduct = false
    },
     handleCurrentChange(pageindex) {
      this.$emit('handleCurrentChange', pageindex)
    },
    handleSizeChange(paegSzie) {
      this.$emit('handleSizeChange', paegSzie)
    },
  }
}
</script>

<style lang="less" scoped>
.ativte {
  border: 1px solid red;
  color: #e71d43;
  background-color: #fce8ec;
  transition: 0.2s linear;
}
 .paginations {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 16px;
    padding-bottom: 16px;
   
  }
.incenters {
  height: 100%;
  font-family: "微软雅黑";
  background-color: #fff;
  width: 980px;
  margin-top: 10px;
  padding-bottom: 10px;
  padding-top: 2px;

  div {
    margin-left: 8px;
    margin-right: 8px;
    margin-top: 5px;
    margin-bottom: 5px;
    // width: 100%;
  }
}

.topstate {
  width: 100px;
  height: 32px;
  font-size: 14px;
  border: 1px solid #e6e6e6;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  display: inline-block;
}
.from {
  width: 100%;
  .inputtop {
    width: 980px;
    height: 40px;
    // box-shadow: 0px 1px 4px 0px rgba(56, 43, 43, 0.1);
    border-bottom: 1px solid #f0f0f0;
    background-color: #ffffff;
    padding-top: 15px;
    padding-bottom: 70px;
    animation: shows 0.2s linear;
    overflow: hidden;
  }

  .inputtops {
    width: 980px;
    height: 0;
    // box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid #f0f0f0;
    background-color: #ffffff;
    padding-top: 15px;
    padding-bottom: 70px;
    overflow: hidden;
    // animation: hides 0.5s ease-in;
  }
}
@keyframes shows {
  0% {
    height: 0px;
  }
  100% {
    height: 40px;
  }
}
@keyframes hides {
  0% {
    opacity: 0;
    height: 40px;
  }
  100% {
    opacity: 1;
    // height: 0px;
  }
}
</style>
